import React from 'react'
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import Calendar from './components/Calendar'
import CalApiContext from './components/CalApiContext'
import SignIn from './components/SignIn';
import Navigation from './components/Navigation';
import { CssBaseline } from '@material-ui/core';

const EventCalendarApp = () => {
  const [calApi, addCalendarContext] = React.useState({})
  const [activeDate, setActiveDate] = React.useState('')
  const value = {calApi, addCalendarContext, activeDate, setActiveDate}
  
  return (
    <CalApiContext.Provider value={value}>
      <Router>
        <CssBaseline/>
        <div>
          <Navigation/>
          <Switch>
            <Route path='/signin'>
              <SignIn/>
            </Route>
            <Route path='/'>
              <Calendar/>
            </Route>
          </Switch>
        </div>
      </Router>
    </CalApiContext.Provider>
  );
}

export default EventCalendarApp;